import baseRequest from "./requests/base-request";
import bizRequest from "./requests/biz-request";
import rongchuangRequest from './requests/rongchuang-request';

export default Object.assign({}, bizRequest, baseRequest, rongchuangRequest);
